import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// import { environment } from '../../../../projects/administration/src/environments/environment';
import { EnvironmentService } from '../../../app/services/environment.service';

import { User } from '../../models/user/user';
import { HelperService } from '../../services/helper/helper.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient,
              private environment: EnvironmentService,
              private helper: HelperService,
              private storageService: StorageService) {

    if (JSON.parse(localStorage.getItem('RememberLogin')) ) {
      this.helper.consoleLog('RemeberedUser');
      this.helper.consoleLog(JSON.parse(localStorage.getItem('RemeberedUser')));
      localStorage.setItem('currentUser', localStorage.getItem('RemeberedUser'));
    }
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {

    return this.currentUserSubject.value;
}

updateCompanyName(companyName: string) {
  const user = this.currentUserValue;
  user.CompanyName = companyName;
  localStorage.setItem('currentUser', JSON.stringify(user));
  this.currentUserSubject.next(user);
}

updateCompanyStatus(status: boolean) {
  const user = this.currentUserValue;
  user.isDisactive = status;
  localStorage.setItem('currentUser', JSON.stringify(user));
  this.currentUserSubject.next(user);
}

updateContractStatus(status: boolean) {
  const user = this.currentUserValue;
  user.isContractActive = status;
  localStorage.setItem('currentUser', JSON.stringify(user));
  this.currentUserSubject.next(user);
}


login(username: string, password: string, rememberLogin: boolean, contextGarageId?: number) {

  const userType = this.environment.getUserType();

  return this.http.post<any>(`${this.environment.getApiURL()}/user/authenticate`, { username, password, userType, contextGarageId })
      .pipe(map(user => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          user.Username = username;

          this.storageService.clearCachedData();

          localStorage.setItem('currentUser', JSON.stringify(user));

          this.currentUserSubject.next(user);

          localStorage.setItem('RememberLogin', JSON.stringify(rememberLogin));

        if (rememberLogin) {
            localStorage.setItem('RemeberedUser', JSON.stringify(user));
          }

          return user;
      }));
  }

/**
 * Logowanie do panelu customer-lite. Osobny endpoint, bo zwykle logowanie wpuszcza
 * wylacznie konta bez ograniczen - a tutaj wchodza takze konta ograniczone do panelu.
 * Typ uzytkownika wraca w odpowiedzi i decyduje, ktory profil zobaczy operator.
 */
loginLite(username: string, password: string, rememberLogin: boolean) {

  const userType = this.environment.getUserType();

  return this.http.post<any>(`${this.environment.getApiURL()}/user/authenticate-lite`, { username, password, userType })
      .pipe(map(user => {
          user.Username = username;

          this.storageService.clearCachedData();

          localStorage.setItem('currentUser', JSON.stringify(user));

          this.currentUserSubject.next(user);

          localStorage.setItem('RememberLogin', JSON.stringify(rememberLogin));

          if (rememberLogin) {
            localStorage.setItem('RemeberedUser', JSON.stringify(user));
          }

          return user;
      }));
  }

loginAldMd5(registrationNumberMd5: string, vinMd5: string, rememberLogin: boolean) {

  return this.http.post<any>(`${this.environment.getApiURL()}/user/authenticate-ald-md5`, { registrationNumberMd5, vinMd5 })
      .pipe(map(user => {
          user.Username = registrationNumberMd5;

          this.storageService.clearCachedData();

          localStorage.setItem('currentUser', JSON.stringify(user));

          this.currentUserSubject.next(user);

          localStorage.setItem('RememberLogin', JSON.stringify(rememberLogin));

        if (rememberLogin) {
            localStorage.setItem('RemeberedUser', JSON.stringify(user));
          }

          return user;
      }));
  }

tfaCodeRequest(user: User) {

  const httpHeaders = new HttpHeaders()
    .set("Content-Type", "application/json")
    .set("Cache-Control", "no-cache");

  const options = { headers: httpHeaders };

  return this.http.post<any>(`${this.environment.getApiURL()}/user/tfa-code-request`, user, options )
    .pipe(map(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes

      this.storageService.clearCachedData();

      localStorage.setItem('currentUser', JSON.stringify(user));

      this.currentUserSubject.next(user);

      return user;
    }));
  }

  tfaCodeAuthenticate(user: User) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.http.post<any>(`${this.environment.getApiURL()}/user/tfa-code-authenticate`, user, options )
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes

        localStorage.setItem('currentUser', JSON.stringify(user));

        this.currentUserSubject.next(user);

        return user;
      }));
  }

remindPassword(username: string, appname: string) {

  // tslint:disable-next-line: max-line-length
  return this.http.post<any>(`${this.environment.getApiURL()}/user/remindpassword`, { Username: username, UserIpAddress: '', ResetLink: '', AppName: appname})
  .pipe(map(data => {
  }));
}

// passwordreset
resetPassword(username: string, password: string, guid: string) {
  if (guid === null) {
    return this.http.post<any>(`${this.environment.getApiURL()}/user/passwordchange`, { Username: username, Password: password, GUID: '00000000-0000-0000-0000-000000000000' })
    .pipe(map(data => {
    }));
  } else {
    return this.http.post<any>(`${this.environment.getApiURL()}/user/passwordreset`, { Username: username, Password: password, GUID: guid })
    .pipe(map(data => {
    }));
  }
}

logout() {
  localStorage.removeItem('currentUser');
  localStorage.removeItem('RememberLogin');
  localStorage.removeItem('RemeberedUser');
  this.currentUserSubject.next(null);
}

}
